export default {
  economyTable: {
    event: 'EVENT',
    importance: 'IMPORTANCE',
    actual: 'ACTUAL',
    forecast: 'FORECAST',
    previous: 'PREVIOUS',
  },
  listImportance: {
    Low: 'LOW',
    Nomal: 'MED',
    High: 'HIGH',
  },
  listLabel: {
    importance: 'Importance',
    weekly: 'WEEKLY VIEW',
    nextWeek: 'Next Week',
    prevWeek: 'Prev. Week',
    unitTitleNote:
      '*Disclaimer: Please be fully informed that the level of importance may not be accurate and should be considered for reference purpose only.',
    unitTitleNote1:
      '*Disclaimer: Please be fully informed that the level of trustability may not be accurate and should be considered for reference purpose only.',
  },
  importance: {
    LOW: 'LOW',
    MED: 'MED',
    HIGH: 'HIGH',
  },
  originalPost: 'Original Post',
  fiinGroupReview: 'FiinGroup Review',
};
